export default __webpack_public_path__ + "static/media/side-about.fbeb2a99.png";